import axios from "axios";
import store from "../store";

class Actions
{
    async get(type = "html") {
		let jwt = store.state.jwt;

		let response = await axios
			.get(`${process.env.VUE_APP_SAAS_BACK}/documentation/` + type, {
				headers: { Authorization: "Bearer " + jwt },
			})
			.then((response) => {
				return response.data.documentation;
			})
			.catch((err) => {
				console.log("Error : ", err);
				return {err};
			});

		return response;
    }
    
    async generate() {
		let jwt = store.state.jwt;

		let response = await axios
			.get(`${process.env.VUE_APP_SAAS_BACK}/documentation/generate`, {
				headers: { Authorization: "Bearer " + jwt },
			})
			.then((response) => {
				return response.data.documentation;
			})
			.catch((err) => {
				console.log("Error : ", err);
				return {err};
			});

		return response;
	}

    async download() {
		var opts = {
			headers: {
				Authorization: "bearer " + store.state.jwt,
			},
		};

		return axios
			.get(`${process.env.VUE_APP_SAAS_BACK}` + "/documentation/download", opts)
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");					
				link.setAttribute("download", "doc.html");
				link.href = url;
				document.body.appendChild(link);
				link.click();
			});

		return response;
    }
}

export default new Actions();